import {
  OVERVIEW_OPTIONS,
  OVERVIEW_DEFAULT,
  MATCH_HISTORY_OPTIONS,
  MATCH_HISTORY_DEFAULT,
  CHAMPION_STATS_OPTIONS,
  CHAMPION_STATS_DEFAULT,
  INDIV_CHAMPION_STATS_OPTIONS,
  INDIV_CHAMPION_STATS_DEFAULT,
} from "./filter_options_profile";

export const validParamsProfile = {
  overview: {
    queueType: OVERVIEW_OPTIONS.queueType,
    role: OVERVIEW_OPTIONS.role,
    season: OVERVIEW_OPTIONS.season,
    default: OVERVIEW_DEFAULT,
    exemptions: ["champion"],
  },
  "match-history": {
    queueType: MATCH_HISTORY_OPTIONS.queueType,
    role: MATCH_HISTORY_OPTIONS.role,
    season: MATCH_HISTORY_OPTIONS.season,
    default: MATCH_HISTORY_DEFAULT,
    exemptions: ["champion"],
  },
  "champion-stats": {
    queueType: CHAMPION_STATS_OPTIONS.queueType,
    role: CHAMPION_STATS_OPTIONS.role,
    season: CHAMPION_STATS_OPTIONS.season,
    default: CHAMPION_STATS_DEFAULT,
  },
  "indiv-champion-stats": {
    queueType: INDIV_CHAMPION_STATS_OPTIONS.queueType,
    role: INDIV_CHAMPION_STATS_OPTIONS.role,
    season: INDIV_CHAMPION_STATS_OPTIONS.season,
    default: INDIV_CHAMPION_STATS_DEFAULT,
  },
  match: {
    default: MATCH_HISTORY_DEFAULT,
  },
};

export const global_exemptions = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "url",
  "gclid",
  "gtm",
  "iframe",
];
